// frontend/src/components/Profile/UserProfileManagement.tsx
import React, { useState } from 'react';
import ProfileHeader from './ProfileHeader';
import BasicInfoForm from './BasicInfoForm';
import PasswordForm from './PasswordForm';
import NotificationSettings from './NotificationSettings';
import { ProfileComponentProps } from './types';

const UserProfileManagement: React.FC<ProfileComponentProps> = ({
  user,
  onUpdateProfile,
  onUpdatePassword,
  onUpdateAvatar,
  isLoading = false
}) => {
  const [avatarUploading, setAvatarUploading] = useState(false);

  const handleAvatarUpdate = async (file: File) => {
    if (!onUpdateAvatar) return { success: false, message: 'Avatar upload not supported' };
    
    setAvatarUploading(true);
    try {
      const result = await onUpdateAvatar(file);
      return result;
    } finally {
      setAvatarUploading(false);
    }
  };

  return (
    <div className="space-y-6 lg:space-y-8">
      {/* Profile Header Section */}
      <ProfileHeader 
        user={user} 
        onUpdateAvatar={onUpdateAvatar ? handleAvatarUpdate : undefined}
        isUploading={avatarUploading}
      />
      
      {/* Settings Grid - Responsive Layout */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 lg:gap-8">
        {/* Left Column */}
        <div className="space-y-6">
          <BasicInfoForm 
            user={user} 
            onUpdate={onUpdateProfile} 
            isLoading={isLoading} 
          />
          
          <PasswordForm 
            onUpdate={onUpdatePassword} 
            isLoading={isLoading} 
          />
        </div>

        {/* Right Column */}
        <div className="space-y-6">
          <NotificationSettings 
            userRole={user?.role as 'admin' | 'provider' | 'customer'} 
          />
          
          {/* Future settings can go here */}
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Privacy Settings</h3>
                <p className="text-sm text-gray-600 mt-1">Control your data and privacy preferences</p>
              </div>
            </div>
            <div className="mt-4 p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-600 text-center">
                Additional privacy settings coming soon
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileManagement;